import { Box, Typography } from '@mui/joy'
import { useFacet, useIntegrationMessages } from 'api/chat-api-integration'
import MessageListItem from 'components/MessageList/MessageListItem'
import Loader from 'elements/Loader/Loader'
import { useState } from 'react'
import { FacetRequestProps, MessagesRequestProps } from 'types/dataManagement'

type Props = {
    startDateTime: any
    endDateTime: any
    integrationList: any
    messagesList: any
    isLoading: boolean
    isFetching: boolean
    setFilters: any
    workspaceId: number
    query: string
}

const MessageList = ({
    integrationList,
    startDateTime,
    endDateTime,
    messagesList,
    isLoading,
    isFetching,
    setFilters,
    workspaceId,
    query,
}: Props) => {
    // console.log(integrationList, 'integrationList messagelist')

    // console.log(data, 'data')
    const [activeFilter, setActiveFilter] = useState('')

    const objectsFacetReqProps: FacetRequestProps = {
        filters: [],
        fields: ['customTags'],
        query: query,
        type: null,
        workspaceId: workspaceId,
        limit: 25,
        startDateTime: startDateTime,
        endDateTime: endDateTime,
    }

    const { data: filterList } = useFacet(objectsFacetReqProps)

    if (isFetching) {
        return <Loader />
    }

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    gap: 2,
                }}
            >
                <Typography
                    onClick={() => {
                        setFilters([])
                        setActiveFilter('')
                    }}
                    sx={{
                        color: activeFilter === '' ? '#006EEE' : 'inherit',
                        '&:hover': {
                            color: '#006EEE',
                            cursor: 'pointer',
                        },
                    }}
                >
                    All Messages{' '}
                    {messagesList?.itemsCount > 0
                        ? `[${messagesList?.itemsCount}]`
                        : null}
                </Typography>
                {filterList?.facet?.map((item: any, index: any) => (
                    <Typography
                        onClick={() => {
                            setFilters([`customTags:${item.key}`])
                            setActiveFilter(item.key)
                        }}
                        sx={{
                            color:
                                activeFilter === item.key
                                    ? '#006EEE'
                                    : 'inherit',
                            '&:hover': {
                                color: '#006EEE',
                                cursor: 'pointer',
                            },
                        }}
                        key={index}
                    >
                        {item.label} {item.value ? `[${item.value}]` : null}
                    </Typography>
                ))}
            </Box>

            {messagesList?.messages?.length > 0 ? (
                messagesList?.messages?.map((item: any, i: number) => (
                    <MessageListItem item={item} key={i} />
                ))
            ) : (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        my: 10,
                    }}
                >
                    <Typography level="h4">
                        No results found. Change search query, filter settings
                        or time period.
                    </Typography>
                </Box>
            )}
        </Box>
    )
}

export default MessageList
